module.exports = __webpack_public_path__ + "static/media/1POLICY8.06423887.jpg";